import { InputNumber, InputNumberProps } from 'antd';
import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './AntdInputNumber.module.less';

type Props = InputNumberProps & {
  label?: string;
  id?: string;
  value?: any;
  prefix?: string;
  name?: string;
};

export const AntdInputNumber = forwardRef<HTMLInputElement, Props>(function AntdInputNumber(
  { className, label, id, prefix, ...props },
  ref
) {
  return (
    <div className={clsx(styles.input, className)}>
      <label htmlFor={id} className="uppercase nowrap">
        {label}
      </label>
      <InputNumber id={id} ref={ref} {...props} />
      {prefix && <span>{prefix}</span>}
    </div>
  );
});
